import React, { useEffect } from 'react';
import { PreviousBillingFormProps } from '@/components/Operator/Stripe/PreviousBillingForm';
import CreditBalance from '@/components/Profile/Billing/CreditBalance';
import PaymentMethods from '@/components/Profile/PaymentMethods';
import BillingHistory from '@/components/Profile/Billing/BillingHistory';
import { usePaymentMethods } from '@/Utils/stripeHooks/usePaymentMethods';
import { User } from '@/API/models';

type Props = PreviousBillingFormProps & {
  stripeKey: string;
  stripe_customer: string;
  stripeSecretKey: string;
  user: User;
};

const ProfileBilling: React.FC<Props> = ({ stripeKey, user }) => {
  const balance = user.stripe_balance;
  const { data: paymentMethods, isLoading: paymentMethodLoading } =
    usePaymentMethods();
  const cleanUrl = () => {
    const newUrl = window.location.origin + '/account/edit#/billing';
    window.history.replaceState({}, document.title, newUrl);
  };
  const isOpenUpgradeModal = !user?.subscription && user?.role === 'user';

  useEffect(() => {
    cleanUrl();
  }, []);

  return (
    <>
      <div className='mt-32 billing-container'>
        {paymentMethodLoading && <p>Loading payment methods...</p>}
        {user?.role === 'user' && <CreditBalance
          balance={balance}
          isOpenUpgradeModal={isOpenUpgradeModal}
        />
        
        }
        <PaymentMethods
          isBooking={false}
          stripeKey={stripeKey}
          paymentMethods={paymentMethods}
        />
        <div>
          <BillingHistory />
        </div>
      </div>
    </>
  );
};

export default ProfileBilling;
